<template>
  <div>
    <v-row align="center" justify="center" class="mx-0">
      <v-col cols="12" sm="12" md="10">
        <v-row
          :class="[$vuetify.breakpoint.mdAndUp ? 'px-10' : '']"
          class="mx-0"
          justify="center"
          align="center"
        >
          <v-col cols="12" sm="12" md="12">
            <v-card v-for="(item,index) in expansiones" :key="index" class="elevation--2 mt-4 pa-6">
              <h2 v-html="item.title" class=" my-0 subtitle font-weight-bold"></h2>
              <p v-html="item.content" class="my-3" style="text-align: justify;"></p>

            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<style scoped>
.pt-header {
  padding-top: 120px;
}
.container {
  padding-left: 20%;
  padding-right: 20%;
}
.subtitle{
  color:#983344;
}
</style>
<script>
export default {
  data: () => ({
    publicPath: process.env.BASE_URL,
    expansiones: [
      {
        title: "¿Quiénes somos?",
        content:
          "Capitálica es una institución financiera sólida debidamente constituida y registrada ante la CONDUSEF y certificada bajo la norma <a href='/POLITICA_CALIDAD.pdf' target='_blank'> ISO-9001-2015 </a>.<br> Todos los contratos de nuestros productos, se encuentran debidamente registrados ante la CONDUSEF, en el RECA y pueden ser consultados en las siguientes páginas oficiales:<br><a href='https://www.gob.mx/condusef/' target='_blank'>https://www.gob.mx/condusef/</a><br><a href='https://phpapps.condusef.gob.mx/reca/_index.php' target='_blank'>https://phpapps.condusef.gob.mx/reca/_index.php</a><br> <br>Forma parte del Grupo ÁLICA, empresas líderes en su ramo que impulsan el desarrollo económico de Nayarit y del Occidente del país. Tenemos la experiencia de 10 años en el mercado, que nos respaldan como una de las empresas financieras más sólidas en el Estado y Puerto Vallarta, Jalisco. <br>Actualmente con más de 3,300 créditos administrados y 2 sucursales (Tepic y Puerto Vallarta)."
      },
      {
        title: "Misión",
        content:
          "Contribuir al crecimiento y desarrollo económico de la región, mediante la oferta de productos se servicios financieros de calidad y oportunidad, cubriendo adecuadamente las necesidades y expectativas de los clientes; con el compromiso ético y de excelencia, asegurando la creación, asegurando la creación de valor para los accionistas."
      },
      {
        title: "Visión",
        content: "Ser la financiera de Occidente a la medida de las necesidades de Crédito para PYMES y de nómina."
      }
    ],
    valores: [
      { text: "Liderazgo", icon: "mdi-human-greeting" },
      { text: "Honestidad", icon: "mdi-hand-heart" },
      { text: "Compromiso", icon: "mdi-charity" },
      { text: "Trabajo en Equipo", icon: "mdi-account-multiple" },
      { text: "Servicio al Cliente", icon: "mdi-headset" },
      { text: "Desarrollo Integral", icon: "mdi mdi-human-male-female" }
    ]
  })
};
</script>
